import { API_BASE_URL } from '../config/api';
import { PUBLIC_CONTENT_CACHE_VERSION } from '../config/contentCache';

const contentUrl = (path, token) => {
  if (token) return `${API_BASE_URL}${path}`;
  return `${API_BASE_URL}${path}?v=${encodeURIComponent(PUBLIC_CONTENT_CACHE_VERSION)}`;
};

/**
 * Fetches dialogue topics from the backend API.
 * @param {string} [token] - Optional Firebase auth token for full access
 * @returns {Promise<Array>} Array of dialogue topic objects
 */
export async function fetchDialogueTopics(token) {
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(contentUrl('/content/dialogue-topics', token), { headers });
  if (!res.ok) {
    throw new Error(`Failed to fetch dialogue topics: ${res.status}`);
  }
  return res.json();
}

export async function fetchDialogueScenario(scenarioId, token) {
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE_URL}/content/dialogue-scenarios/${scenarioId}`, { headers });
  if (!res.ok) {
    const error = new Error(`Failed to fetch dialogue scenario: ${res.status}`);
    error.status = res.status;
    throw error;
  }
  return res.json();
}

/**
 * Fetches discussion topics from the backend API.
 * @param {string} [token] - Optional Firebase auth token for full access
 * @returns {Promise<Array>} Array of discussion topic objects
 */
export async function fetchDiscussionTopics(token) {
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(contentUrl('/content/discussion-topics', token), { headers });
  if (!res.ok) {
    throw new Error(`Failed to fetch discussion topics: ${res.status}`);
  }
  // The backend returns discussion topics in an ad-hoc order (Nourriture first);
  // sort by id so every consumer — the catalog grid, the topic Next/Previous
  // footer, vocab/flashcards — matches the id order the sidebar and the "By topic"
  // catalog already use. Dialogue topics are already id-ordered, so they need none.
  const topics = await res.json();
  return Array.isArray(topics) ? [...topics].sort((a, b) => Number(a.id) - Number(b.id)) : topics;
}
